export const ASAAS_PAY_TYPE = 'asaas' as const;
export const ASAAS_CURRENCY = 'BRL';
export const ASAAS_POLL_INTERVAL_MS = 3000;
export const ASAAS_POLL_WINDOW_MS = 60_000;
export const ASAAS_MAX_QUERY_FAILURES = 3;
export const ASAAS_PENDING_TTL_MS = 24 * 60 * 60 * 1000;
export const ASAAS_PAYMENT_STATUS = {
  PENDING: 1,
  SUCCEEDED: 2,
  FAILED: 3,
  CANCELLED: 4,
} as const;
export type AsaasPaymentStatus = (typeof ASAAS_PAYMENT_STATUS)[keyof typeof ASAAS_PAYMENT_STATUS];

export type AsaasPaymentSource =
  | 'purchase'
  | 'upgrade-renew'
  | 'traffic'
  | 'lightweight'
  | 'billing';

export type AsaasCheckoutOpenError = 'blocked' | 'failed';

export interface AsaasOrderInfo {
  orderCode: string;
  payType?: Pay.PayType;
  currency: string;
  packageId: number;
  orderAction: Pay.OrderType;
  discountTotalPrice: string;
  accountNum?: number;
  durationNum?: number;
  regionPackageId?: string | null;
  validStartStr?: string;
  validEndStr?: string;
  handleNum?: number;
  trafficPackageType?: Pay.TrafficPackageType;
  orderNumber?: number;
  paymentUrl?: string;
  checkoutOpenError?: AsaasCheckoutOpenError;
}

export interface AsaasPendingPayment {
  orderCode: string;
  createdAt: number;
  source: AsaasPaymentSource;
  order: AsaasOrderInfo;
}

export interface AsaasCheckoutAttempt {
  returnId: string;
}

export interface AsaasOrderAttempt extends AsaasCheckoutAttempt {
  idempotent: string;
  payResultUrl?: string;
  idempotencyScope: string;
}

export type AsaasPaymentPhase =
  | 'querying'
  | 'pending'
  | 'confirming'
  | 'succeeded'
  | 'failed'
  | 'cancelled'
  | 'error'
  | 'unrecoverable';

export interface AsaasPaymentSnapshot {
  orderCode: string;
  phase: AsaasPaymentPhase;
  polling: boolean;
  retryable: boolean;
  paymentStatus?: AsaasPaymentStatus;
  error?: Error;
}

export interface AsaasPaymentWatcher {
  orderCode: string;
  getSnapshot(): AsaasPaymentSnapshot;
  subscribe(listener: (snapshot: AsaasPaymentSnapshot) => void): () => void;
  refresh(): void;
  requestCheck(): void;
}

export type AsaasCheckoutOpenResult = 'opened' | 'blocked' | 'failed';
